module.exports = __webpack_public_path__ + "img/DemolitionExpert.d0de0b94.png";